export default "__VITE_ASSET__CwOi$ELO__"